import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import AGBPage from './pages/AGBPage';
import { trackScrollDepth } from './utils/analytics';

function App() {
  useEffect(() => {
    let scrollPercentages = [25, 50, 75, 90];
    let trackedPercentages = new Set();

    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight - windowHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollPercentage = Math.round((scrollTop / documentHeight) * 100);

      scrollPercentages.forEach(percentage => {
        if (scrollPercentage >= percentage && !trackedPercentages.has(percentage)) {
          trackedPercentages.add(percentage);
          trackScrollDepth(percentage);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App min-h-screen bg-white">
          <ScrollToTop />
          
          <Header />
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/projekte/:slug" element={<ProjectDetailPage />} />
              <Route path="/ueber-mich" element={<AboutPage />} />
              <Route path="/leistungen" element={<ServicesPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/agb" element={<AGBPage />} />
            </Routes>
          </main>
          <Footer />
          <BackToTop />
          <CookieConsent />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App; 